module.exports = new __parcel__URL__("leaderboard_divider_v2.e761eafd.png").toString();